export const getPermanentEmployeeId = (employee = {}) =>
  employee.permanentEmployeeId || employee.permanentId || employee.permId || '';

export const getTemporaryEmployeeId = (employee = {}) =>
  employee.tempEmployeeId || employee.temporaryEmployeeId || employee.temporaryId || employee.tempId || '';

export const getPreferredEmployeeId = (employee = {}) =>
  getPermanentEmployeeId(employee) || getTemporaryEmployeeId(employee) || '';

export const getPreferredEmployeeIdLabel = (employee = {}) =>
  getPermanentEmployeeId(employee)
    ? 'Permanent ID'
    : getTemporaryEmployeeId(employee)
      ? 'Temporary ID'
      : 'Employee ID';
